"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = void 0;
const react_1 = require("@emotion/react");
const utils_1 = require("@obvio/utils");
function parseArgs(args, theme, props) {
    return args.map((argument) => {
        let arg = argument;
        while (typeof arg === 'function' && !String(arg).startsWith('.')) {
            arg = arg(theme, props);
        }
        return Array.isArray(arg) ? parseArgs(arg, theme, props) : arg;
    });
}
function isTemplateStringsArray(v) {
    return Array.isArray(v) && Array.isArray((0, utils_1.get)(v, 'raw'));
}
function css(...args) {
    const arg0 = isTemplateStringsArray(args[0]) ? [args.shift()] : [];
    return (theme, ...props) => (0, react_1.css)(...arg0, ...parseArgs(args, theme, ...props));
}
exports.css = css;
